module.exports = {"title":"My data","deleteAccountButton":"Delete my account","meta":"Account"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/account.json
// module id = h4Gu
// module chunks = 1